var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyFoodDeliveryNot = function SvgHappyFoodDeliveryNot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5F7",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M10.56 7.5a1.75 1.75 0 0 0 1.75-1.75 1 1 0 0 0 0-.11.15.15 0 0 1 .03-.1.14.14 0 0 1 .09-.04h.38a.5.5 0 0 0 0-1h-1a.1.1 0 0 1-.06-.035A1.75 1.75 0 1 0 10.56 7.5m0-1a.75.75 0 0 1-.75-.75 1 1 0 0 1 0-.155.13.13 0 0 1 .14-.095h1.225a.13.13 0 0 1 .12.095 1 1 0 0 1 0 .155.75.75 0 0 1-.735.75M7.565 7.75h-3a.5.5 0 0 0-.5.5v2.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-2.5a.5.5 0 0 0-.5-.5M10.81 7.625A1.625 1.625 0 0 0 9.19 9.25v1.5a.62.62 0 0 0 .62.625H11a.125.125 0 0 1 .12.085l.58 1.74a.62.62 0 0 0 .59.425q.102 0 .2-.03a.63.63 0 0 0 .395-.795l-.75-2.25a.625.625 0 0 0-.595-.425h-1a.125.125 0 0 1-.12-.125v-.75a.37.37 0 0 1 .18-.32.13.13 0 0 1 .125 0l2 1.12a.624.624 0 1 0 .605-1.09l-2.25-1.25a.6.6 0 0 0-.27-.085M7.815 16a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M13.81 16a1.125 1.125 0 0 0 1.19-.72.14.14 0 0 0 0-.11.13.13 0 0 0-.1-.045h-2.175a.13.13 0 0 0-.1.045.14.14 0 0 0 0 .11 1.12 1.12 0 0 0 1.185.72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M6.94 11.75a1.88 1.88 0 0 0-1.88 1.875v.625a.5.5 0 0 0 1 0v-.625a.88.88 0 0 1 .88-.875h1.87a.75.75 0 0 1 .75.75v.25a1 1 0 0 0 .5.855.14.14 0 0 0 .065 0h5.44a.38.38 0 0 0 .375-.375 1.56 1.56 0 0 0-1.28-1.55.125.125 0 0 1-.1-.12v-.61a.13.13 0 0 1 .06-.105.14.14 0 0 1 .125 0l.455.23a.245.245 0 0 0 .36-.225v-.945a.245.245 0 0 0-.36-.225l-.455.23a.14.14 0 0 1-.125 0 .14.14 0 0 1-.06-.105V10.5a.5.5 0 0 0-1 0v3.125a.125.125 0 0 1-.12.125h-2.75a.13.13 0 0 1-.13-.125V13.5a1.7 1.7 0 0 0-.125-.635.13.13 0 0 1 .065-.165.5.5 0 0 0 .305-.45.5.5 0 0 0-.5-.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#happyFoodDeliveryNot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3A5C",
    strokeLinecap: "round",
    d: "M16 4.707 4.707 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "happyFoodDeliveryNot_svg__a",
    width: 12.293,
    height: 13.293,
    x: 4.207,
    y: 3.207,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3004_230",
    result: "shape"
  })))));
};
export default SvgHappyFoodDeliveryNot;